import { z } from 'zod';

// The visitor's colour preference. `system` follows the operating system's
// `prefers-color-scheme`; the other two pin the portal regardless of it.
export const THEMES = ['light', 'dark', 'system'] as const;

export type Theme = (typeof THEMES)[number];

export const DEFAULT_THEME: Theme = 'system';

// The resource route the account menu's fetcher posts `theme` to.
export const THEME_RESOURCE_PATH = '/resources/theme';

export const themeSchema = z.enum(THEMES);
